module.exports = __webpack_public_path__ + "img/memberOne.9fe0ce7b.svg";